import store from '../redux/store';
import axios from 'axios';
import Cookies from 'js-cookie';

function userLogout(withRedirect: boolean = true): void {
	store.dispatch({ type: 'reset-state' });
	axios.defaults.headers.common['Authorization'] = '';
	Cookies.remove('Token');
	if (withRedirect) {
		window.history.pushState({}, '', '/login');
	}
}

const deinitialization = {
	userLogout,
};

export default deinitialization;
